"use client";

import React, { useEffect, useState } from 'react'
import Image from "next/image";
import close from '../../public/images/x.svg'

import Link from 'next/link';
import logo from '../../public/images/logo.webp'
import { plan1 as Icon_plan1 } from "@/components/customer/icons/plan1";
import { plan2 as Icon_plan2 } from "@/components/customer/icons/plan2";
import { plan3 as Icon_plan3 } from "@/components/customer/icons/plan3";
const SvgIcons = { plan1: Icon_plan1, plan2: Icon_plan2, plan3: Icon_plan3 };
import { useRouter } from 'next/navigation';

declare global {
  interface Window {
    Razorpay: any;
  }
}

interface RazorpayResponse {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}


interface RazorpayOptions {
  key: string;
  amount: number;
  currency: string;
  name: string;
  description: string;
  order_id: string;
  handler: (response: RazorpayResponse) => void;
  prefill: any;
  notes: any;
  theme: any;
}

export const ChoosePlan = () => {


  const [businessName, setBusinessName] = useState('');
  const [businessType, setBusinessType] = useState();
  const [industryType, setIndustryType] = useState();
  const [themeId, setThemeId] = useState(3);
  // const [planId, setPlanId] = useState(1);
  const [responseMessage, setResponseMessage] = useState('');

  const [isOpen, setIsOpen] = useState(false);

  const router = useRouter();

  const authToken: string =
    (typeof window !== "undefined" ? localStorage.getItem("authToken") : null) || "";
  useEffect(() => {
    const storedFormData = JSON.parse(localStorage.getItem("formData") || "{}");
    const theameID = JSON.parse(localStorage.getItem("theameId") || "{}");
    console.log(storedFormData,"storedFormData")
    setBusinessName(storedFormData?.business_name || "");
    setBusinessType(storedFormData?.business_type || "");
    setIndustryType(storedFormData?.industry_type || "");
    setThemeId(theameID?.theme_id || "");
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  
  const handleSubmit = async () => {
    // Basic auth is now injected server-side by /api/purchase-pay-request, so the credential no
    // longer ships in the client bundle. We still forward the per-user token.
    const myHeaders = new Headers();
    myHeaders.append("token", authToken);
    myHeaders.append("Content-Type", "application/json");
  
    const raw = JSON.stringify({
      business_name: businessName,
      business_type: businessType,
      industry_type: industryType,
      theme_id: themeId,
      plan_id: planId,
    });
  
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow" as RequestRedirect,
    };
  
    try {
      const response = await fetch(
        "/api/purchase-pay-request",
        requestOptions
      );
  
      const result = await response.json();
      console.log("API Response:", result);
  
      if (result.status && result.datas?.callback_url && result.datas?.order_id && result.datas?.key) {
        const paymentData = {
          key: result.datas.key,
          amount: result.datas.amount * 100, // Convert to paise
          currency: result.datas.currency,
          description: "Vilva Business Payment",
          order_id: result.datas.order_id,
          callback_url: result.datas.callback_url, // Callback URL for post-payment verification
          notes: {
            business_name: businessName,
          },
          theme: {
            color: "#3399cc",
          },
        };
  
        console.log("Opening Razorpay with data:", paymentData);
  
        if (!window.Razorpay) {
          console.error("Razorpay SDK not loaded");
          return;
        }
  
        // Initialize Razorpay
        const options: any = {
          key: paymentData.key,
          amount: paymentData.amount,
          currency: paymentData.currency,
          name: "Vilva Business",
          description: paymentData.description,
          order_id: paymentData.order_id,
          handler: async (paymentResponse: any) => {
            console.log("Payment successful", paymentResponse);
  
            // Prepare data for callback API
            const postData = {
              razorpay_order_id: paymentResponse.razorpay_order_id,
              razorpay_payment_id: paymentResponse.razorpay_payment_id,
              razorpay_signature: paymentResponse.razorpay_signature,
              order_id: paymentData.order_id, // Ensure order_id is included
              notes: paymentData.notes, // Send additional notes if needed
            };
  
            console.log("Sending payment details to callback URL:", postData);
  
            try {
              // Send payment details to the callback URL
              const callbackResponse = await fetch(paymentData.callback_url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(postData),
              });
  
              const callbackResult = await callbackResponse.json();
              console.log("Callback Response:", callbackResult);
  
              if (callbackResult.code == 200) {
                setIsOpen(true);
                console.log("Payment verified successfully!");
                // localStorage.setItem("authStatus", "active");
 
              } else {
                console.error("Payment verification failed:", callbackResult);
              }
            } catch (error) {
              console.error("Error calling callback URL:", error);
            }
          },
          notes: paymentData.notes,
          theme: paymentData.theme,
        };
  
        const rzp = new window.Razorpay(options);
        console.log("Opening Razorpay Checkout...");
        rzp.open();
  
        rzp.on("payment.failed", (_response: { error: any }) => {
          console.error("Payment failed:", _response.error);
        });
      } else {
        setResponseMessage(result.message || "Something went wrong");
      }
    } catch (error: any) {
      console.error("Error:", error);
      setResponseMessage("Error: " + error.message);
    }
  };
  
  

  const cards = [
    {
      plan_id: 1,
      image: <SvgIcons.plan1/>,
      title: "Website (₹4999)",
      count: 324,
    },
    {
      plan_id: 2,
      image: <SvgIcons.plan2/>,
      title: "App (₹9999)",
      count: 24,
    },
    {
      plan_id: 3,
      image: <SvgIcons.plan3/>,
      title: "Website + App (₹14999)",
      count: 24,
    },
  ];
  
    // Find the index of the card with plan_id: 1
    const defaultIndex = cards.findIndex((card) => card.plan_id === 1);
  
    // State to track the active card index and selected plan ID
    const [activeCard, setActiveCard] = useState<number | null>(defaultIndex);
    const [planId, setPlanId] = useState<number | null>(
      cards[defaultIndex]?.plan_id ?? null
    );
  
    // Ensure first card is always active on mount
    useEffect(() => {
      setActiveCard(defaultIndex);
      setPlanId(cards[defaultIndex]?.plan_id ?? null);
    }, [defaultIndex]);
  
    // Handle card click
    const handleCardClick = (index: number) => {
      setActiveCard(index);
      const selectedPlan = cards[index];
  
      if (selectedPlan?.plan_id !== undefined) {
        setPlanId(selectedPlan.plan_id);
        console.log("Selected Plan ID:", selectedPlan.plan_id);
      }
    };


    // const storedFormData = JSON.parse(localStorage.getItem("formData") || "{}");
    // const businessName = storedFormData?.business_name || "";
    // const businesstype = storedFormData?.business_type || "";
    // const industrytype = storedFormData?.industry_type || "";

    // console.log("storedFormData",storedFormData);
    // console.log("business_type",storedFormData.business_type);
    // console.log("industry_type",storedFormData.industry_type);

    const savedFormData =
      typeof window !== "undefined"
        ? JSON.parse(localStorage.getItem("formData") || "{}")
        : {};
    const themeid = savedFormData?.theme_id || "";

    console.log("Theme ID:", savedFormData.theme_id);

  return (
    <div>


{isOpen && (
  <div className="min-h-screen fixed inset-0 succestick  bg-black/50 z-50 flex items-center justify-center">
  <div className="bg-white p-10 rounded-[10px] shadow-lg max-w-md text-center relative">
 
    {/* <img src={righttick} alt="Success" width="100px" className="mx-auto mb-4" /> */}
    <h2 className="text-3xl font-bold text-green-700">Payment Successful!</h2>
    <p className="text-md mt-4 text-gray-700">Our representative will reach out to you shortly. In the meantime, you can explore our other products and services. You can also reach us on WhatsApp at <a className='font-bold' href="https://api.whatsapp.com/send?phone=91%2091765%2069459&text=Hello%20Vilva%20Bunsiness" target='_blank'>+91 9176569459</a> </p>
    <button
      onClick={() => { window.location.href = "/"; }}
      className="mt-6 px-6 py-3 font-semibold text-white bg-green-500 hover:bg-green-600 rounded-md transition duration-300"
    >
      Continue
    </button>
  </div>
</div>
      )}

<section>
  <div className="flex min-h-screen items-center justify-center bg-[#CADCEE]">
    <div className="w-[988px] sm:h-auto h-[100vh]  bg-white sm:rounded-2xl rounded-0 p-3 sm:shadow-lg shadow-0 sm:mx-3 mx-0 sm:my-3 my-0">
    <div className='block sm:hidden mt-[16px]'>
        <div className=' justify-center flex'>
         <Link href='/' aria-label="Go to Vilva Business homepage"><Image alt="Vilva Business logo" className='cursor-pointer' src={logo}/></Link>
        </div>
      </div>
      <div className="flex justify-between items-center p-4 sm:p-5 pt-[30px] sm:pt-[0px]">
        <div>
          <p className="text-[#090D28] text-xl font-semibold sm:text-2xl">Select Your Plan</p>
          <p className="text-[#090D28] text-sm sm:text-sm">Build Your Stunning Website within 48 Hours</p>
        </div>
        <div className='bg-[#EBEBEB] hidden sm:block rounded-md p-1'>
          <Image alt="Close" className='cursor-pointer' src={close}/>
        </div>
      </div>

      {/* <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3'>
        <div className='card relative flex flex-col justify-center items-center m-3 rounded-xl p-5 border cursor-pointer border-[#5CB5F3] bg-gradient-to-b from-[#5CB5F3] to-[#005CE5] shadow-[0_4px_25px_rgba(8,99,231,0.45)] h-[216px]  flex-shrink-0'>
            <div className='flex justify-center pb-6'>
                <Image alt="Vilva Business website plan 1" className='cursor-pointer' src={plan1}/>
            </div>
            <div className='flex justify-between w-full items-center px-5 mb-3 absolute bottom-0'>
                <div className='flex items-center'>
                <input 
              type="radio" 
              className="h-4 w-4 text-[#5CB5F3] border-[#5CB5F3] focus:ring-[#5CB5F3] checked:border-2 checked:border-[#005CE5]"
            />
                    <p className='text-white ml-3 text-[14px]'>Website (₹4999)</p>
                </div>
                <div className=''>
                    <div className='flex items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shopping-cart text-[#A6CCE7]"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
                        <p className='text-[#A6CCE7] ml-2 text-[13px]'>324</p>
                    </div>
                </div>
            </div>
        </div>
        <div className='card relative flex flex-col justify-center items-center m-3 rounded-xl p-5 border cursor-pointer border-[#BAC7D4] bg-gradient-to-b from-white to-[#E4F1FF] shadow-[0_4px_25px_rgba(8,99,231,0.45)] h-[216px]  flex-shrink-0'>
            <div className='flex justify-center pb-6'>
                <Image alt="Vilva Business website plan 2" className='cursor-pointer' src={plan2}/>
            </div>
            <div className='flex justify-between w-full items-center mt-5  px-5 mb-3 absolute bottom-0'>
                <div className='flex items-center'>
                    <input 
                        type="radio" 
                        className="h-4 w-4 text-[#5CB5F3] border-[#BAC7D4] focus:ring-[#5CB5F3] checked:border-2 checked:border-[#005CE5]"
                    />
                    <p className='text-[#454756] ml-3 text-[14px]'>App (₹9999)</p>
                </div>
                <div className=''>
                    <div className='flex items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shopping-cart text-[#666A84]"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
                        <p className='text-[#454756] ml-2 text-[13px]'>24</p>
                    </div>
                </div>
            </div>
        </div>
        <div className='card relative flex flex-col justify-center items-center m-3 rounded-xl p-5 border cursor-pointer border-[#BAC7D4] bg-gradient-to-b from-white to-[#E4F1FF] shadow-[0_4px_25px_rgba(8,99,231,0.45)] h-[216px] flex-shrink-0'>
            <div className='flex justify-center pb-6'>
                <Image alt="Vilva Business website plan 3" className='cursor-pointer' src={plan3}/>
            </div>
            <div className='flex justify-between w-full items-center mt-5 '>
                <div className='flex items-center'>
                    <input 
                        type="radio" 
                        className="h-4 w-4 text-[#5CB5F3] border-[#BAC7D4] focus:ring-[#5CB5F3] checked:border-2 checked:border-[#005CE5]"
                    />
                    <p className='text-[#454756] ml-3 text-[14px]'>Website + App (₹14999)</p>
                </div>
                <div className=''>
                    <div className='flex items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shopping-cart text-[#666A84]"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
                        <p className='text-[#454756] ml-2 text-[13px]'>24</p>
                    </div>
                </div>
            </div>
        </div>
      </div> */}

      <div className='grid  md:grid-cols-3 lg:grid-cols-3 '>
        {cards.map((card, index) => (
          <div
            key={index}
            className={`card relative flex flex-col justify-center items-center m-3 rounded-xl p-5 border cursor-pointer 
              ${activeCard === index 
                ? 'border-[#5CB5F3] bg-gradient-to-b from-[#5CB5F3] to-[#005CE5] shadow-[0_4px_25px_rgba(8,99,231,0.45)]' 
                : 'border-[#BAC7D4] bg-gradient-to-b from-white to-[#E4F1FF] '
              } 
              h-[216px] flex-shrink-0 transition-all duration-300 hover:scale-[1.02]`}
            onClick={() => handleCardClick(index)}
          >
            <div className='flex justify-center pb-6'>
              {/* <Image alt="image tag" className='cursor-pointer' src={card.image} /> */}
              {card.image}
            </div>
            <div className='flex justify-between w-full items-center px-5 mb-3 absolute bottom-0'>
              <div className='flex items-center'>
                <input
                  type="radio"
                  className="h-4 w-4 text-[#5CB5F3] focus:ring-[#5CB5F3] checked:border-2 checked:border-[#005CE5]"
                  checked={activeCard === index}
                  onChange={() => handleCardClick(index)}
                />
                <p
                  className={`ml-3 text-[14px] ${
                    activeCard === index ? 'text-white' : 'text-[#454756]'
                  }`}
                >
                  {card.title}
                </p>
              </div>
              <div className=''>
                <div className='flex items-center'>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`lucide lucide-shopping-cart ${
                      activeCard === index ? 'text-[#A6CCE7]' : 'text-[#666A84]'
                    }`}
                  >
                    <circle cx="8" cy="21" r="1" />
                    <circle cx="19" cy="21" r="1" />
                    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                  </svg>
                  <p
                    className={`ml-2 text-[13px] ${
                      activeCard === index ? 'text-[#A6CCE7]' : 'text-[#454756]'
                    }`}
                  >
                    {card.count}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className=' block justify-center w-full items-center md:flex m md:justify-between lg:items-center p-4'>
        <div className='flex justify-center order-1 md:order-2'>
        
            <button className='bg-[#217DF8] rounded-md w-full cursor-pointer py-3 px-9 text-white ' onClick={handleSubmit}>Create website Now</button>
       
        </div>
        <div className='flex justify-center order-2 md:order-1 my-3'>
        <Link href="/viewplan">
            <p className='text-[16px] underline text-[#217DF8]'><a className='' href="/viewplan">View Plan Details</a></p>
        </Link>
        </div>
      </div>

      <div className='block sm:hidden '>
        <div className=' justify-center flex w-full mx-auto pb-[16px]'>
         <p className='text-[10px] whitespace-nowrap'>© Copyright 2025 <a target='_blank'  className='text-[#1672F1]' href="https://www.vilvabusiness.com/">Vilva Business </a>All Rights Reserved</p>
        </div>
      </div>

    </div> 
  </div>
</section>

    </div>
  )
}
